import TableUnderMapSingleType  from "./TableUnderMapSingleType";
import TableUnderMapMultiType  from "./tableUnderMapGroup/TableUnderMapGroup";
import TableUnderMapNoType from "./TableUnderMapNoType";
import { useMapURLParams } from "../../../hooks/map/useMapParams";
import { MapName } from "../../../stateManagement/reducers/maps/actions";

type TableUnderMapAutoProps = {
    objectTypes: string | string[] | undefined,
    canBeFiltered?: boolean,
    filters?: Record<string, string>
}

export default function TableUnderMap({ objectTypes, canBeFiltered = false, filters = {} }: TableUnderMapAutoProps) {
    const { mapName } = useMapURLParams() as { mapName: MapName; mapOption?: string };
    if (objectTypes == null) {
        return <TableUnderMapNoType />
    }

    if (Array.isArray(objectTypes)) {
        return (
            <TableUnderMapMultiType 
                mapName={mapName}
                objectTypes={objectTypes}
                canBeFiltered={canBeFiltered}
                filters={filters}
            />
        )
    }

    return (
        <TableUnderMapSingleType 
            mapName={mapName}
            objectType={objectTypes}
            canBeFiltered={canBeFiltered}
            filtersExpression={filters?.[objectTypes]}
        />
    )
}


